interface V3IconDownloadProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
    size?: string;
}

export const V3IconDownload = ({ stroke = "#6E7687", size = "24", ...rest }: V3IconDownloadProps) => (
    <svg width={size} height={size} {...rest} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
